import { render } from "./PriceModal.vue?vue&type=template&id=12e5cae8&scoped=true"
import script from "./PriceModal.vue?vue&type=script&lang=js"
export * from "./PriceModal.vue?vue&type=script&lang=js"

import "./PriceModal.vue?vue&type=style&index=0&id=12e5cae8&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12e5cae8"]])

export default __exports__